export const customerStatusTableEndpoint = "/orders";
export const customerAgentDetailsEndpoint = (orderId) =>
  `orders/${orderId}`;
export const orderServiceEndpoint = (orderId) => `orders/${orderId}`;
export const viewCCDetailaAPI = (orderId) =>
  `orders/${orderId}/credit-card-data`;
export const statusEndpoint = "/statuses";
export const rejectStatusEndpoint = (params) =>
  `/statuses?status_category=${params}`;
export const resendEmailAPI = (orderId) => `/orders/${orderId}/resend-email`;
export const orderLogEndpoint = (orderId) => `orders/${orderId}/user-logs`;
export const plansEndpoint = (page, limit, searchtext) =>
  `/plans?page=${page}&limit=${limit}&searchtext=${searchtext}`;
export const addPlanEndpoint = `/plans`;
export const planDetailsEndpoint = (id) => `/plans/${id}`;
export const devicesEndpoint = (page, limit, searchtext) =>
  `/devices?page=${page}&limit=${limit}&searchtext=${searchtext}`;
export const deviceDetailsEndpoint = (id) => `/devices/${id}`;
export const addDeviceEndpoint = () => `/devices`;
export const addonsEndpoint = (page, limit, searchtext) =>
  `/addons?page=${page}&limit=${limit}&searchtext=${searchtext}`;
export const statesEndpoint = "/locations/states";
export const addAddonsEndpoint = `/addons`;
export const addonDetailsEndpoint = (id) => `/addons/${id}`;
export const downloadCsvEndpoint = (params) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([_, value]) => value)
  ).toString();

  return `orders/download-csv?${query}`;
};
export const credentialsEndpoint = (orderId) =>
  `orders/${orderId}/prepare-cred-mail`;
export const sendCredentialsEndpoint = (orderId) =>
  `orders/${orderId}/send-cred-mail`;
export const healthCheckEndpoint =  "health-check"